import { render, staticRenderFns } from "./IristarHistory.vue?vue&type=template&id=00fc42f4&scoped=true&"
import script from "./IristarHistory.vue?vue&type=script&lang=js&"
export * from "./IristarHistory.vue?vue&type=script&lang=js&"
import style0 from "./IristarHistory.vue?vue&type=style&index=0&id=00fc42f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc42f4",
  null
  
)

export default component.exports